//Safeguard against Skio's multiple instances running
if(typeof window.recipeSwiperInitialised == "undefined"){
  window.recipeSwiperInitialised = false;
  window.merchSwiperInitialised = false;
}

const openReadMoreOverlay = (overlayContainers,targetProductName) => {
  overlayContainers.forEach((overlayContainer) => {              
    if(overlayContainer.dataset.productName == targetProductName){
      overlayContainer.querySelector(".loyalty-product__read-more-overlay").style.display = "block";
      overlayContainer.querySelector(".loyalty-product__read-more-overlay-bg").style.display = "block";                
    }
  });
}

const bindReadMoreOverlays = () => {
  const readMoreContainers = document.querySelectorAll(".loyalty-product-card__read-more-container");
  if(readMoreContainers){
    const overlayContainers = document.querySelectorAll(".skio-loyalty-rewards__product-overlays .loyalty-product__read-more-overlay-container");
    if(overlayContainers){

      readMoreContainers.forEach((readMoreContainer) => {


        //Bind opening of clicking "Read More"
        const trigger = readMoreContainer.querySelector(".loyalty-product-card__read-more-trigger");
        if(trigger){
          const targetProductName = trigger.dataset.productTitle;
          if(targetProductName){

            //Bind Clicking of Read More
            trigger.addEventListener("click",() => {            
              openReadMoreOverlay = openReadMoreOverlay(overlayContainers,targetProductName);
            });

            //However, the Image itself and the Product Title need to open the overlay also
            const cardContainer = trigger.closest(".loyalty-product-card");
            if(cardContainer){                
              const productCardImage = cardContainer.querySelector(".loyalty-product-card__image");

              if(productCardImage){
                productCardImage.addEventListener("click",() => {            
                  openReadMoreOverlay = openReadMoreOverlay(overlayContainers,targetProductName);
                });
              }

              const productTitle = cardContainer.querySelector(".loyalty-product-card__content-header-title");
              if(productTitle){
                  productTitle.addEventListener("click",() => {            
                  openReadMoreOverlay = openReadMoreOverlay(overlayContainers,targetProductName);
                });
              }
            }
          }                    
        }
      });

      overlayContainers.forEach((overlayContainer) => {
          const overlay = overlayContainer.querySelector(".loyalty-product__read-more-overlay");
          const overlayBg = overlayContainer.querySelector(".loyalty-product__read-more-overlay-bg");
          if(overlay && overlayBg){
            overlayBg.addEventListener("click",() => {
              overlayBg.style.display = "none";
              overlay.style.display = "none";
            });

            const closeButton = overlay.querySelector(".loyalty-product__read-more-overlay-close");
            if(closeButton){
              closeButton.addEventListener("click",() => {
                overlayBg.style.display = "none";
                overlay.style.display = "none";
              });
            }
          }
      });
    }
  }
}

class SkioSDK {
  constructor({ domain, debug } = { domain: null, debug: false }) {
    this.domain = domain;
    this.debug = debug;

    this.storefrontUser = {
      id: null,
      idToken: null,
      accessToken: null,
      refreshToken: null,
      firstName: null,
      lastName: null,
      createdAt: null,
      email: null,
    };

    this.localStorageKeys = {
      idToken: null,
      accessToken: null,
      refreshToken: null,
    };

    this.clientId = null;

    this.init();
  }

  init() {
    this.log('Initializing Skio');

    if (!this.domain) {
      this.debug = true;
      this.error('Domain is required');
      return;
    }

    this.checkLogin();
  }

  checkLogin() {
    for (const [key, value] of Object.entries(window.localStorage)) {
      if (key === 'storefrontUserFirstName') {
        this.storefrontUser.firstName = JSON.parse(value);
      }

      if (key === 'storefrontUserLastName') {
        this.storefrontUser.lastName = JSON.parse(value);
      }

      if (key === 'storefrontUserEmail') {
        this.storefrontUser.email = JSON.parse(value);
      }

      if (key.includes('CognitoIdentityServiceProvider')) {
        if (key.includes('idToken')) {
          this.localStorageKeys.idToken = key;
          this.storefrontUser.idToken = value;
        }

        if (key.includes('accessToken')) {
          this.localStorageKeys.accessToken = key;
          this.storefrontUser.accessToken = value;
        }

        if (key.includes('refreshToken')) {
          this.localStorageKeys.refreshToken = key;
          this.storefrontUser.refreshToken = value;
        }

        this.clientId = key.split('.')[1];
      }
    }

    this.storefrontUser.id = JSON.parse(
      window.localStorage.getItem('storefrontUserId'),
    );

    return this.storefrontUser.idToken ? true : false;
  }

  // SECTION: Utility Functions
  log(...args) {
    if (!this.debug) return;
    args.unshift(`%c[SkioSDK]`, 'color: #8770f2;');
    console.log.apply(console, args);
  }

  error(...args) {
    if (!this.debug) return;
    args.unshift(`%c [SkioSDK]`, 'color: #ff0000');
    console.error.apply(console, args);
  }

  isCustomerLoggedIntoShopify() {
    return window.ShopifyAnalytics?.meta?.page?.customer_id ? true : false;
  }

  isCustomerLoggedIntoSkio() {
    return this.storefrontUser.id ? true : false;
  }

  async getNewToken() {
    let data = {
      AuthFlow: 'REFRESH_TOKEN_AUTH',
      AuthParameters: {
        REFRESH_TOKEN: this.storefrontUser.refreshToken,
      },
      ClientId: this.clientId,
    };

    try {
      const response = await fetch(
        'https://cognito-idp.us-west-2.amazonaws.com/',
        {
          method: 'POST',
          headers: {
            'content-type': 'application/x-amz-json-1.1',
            'x-amz-target': 'AWSCognitoIdentityProviderService.InitiateAuth',
          },
          body: JSON.stringify(data),
        },
      );

      const responseData = await response.json();
      const accessToken = responseData.AuthenticationResult.AccessToken;
      const idToken = responseData.AuthenticationResult.IdToken;

      this.storefrontUser.accessToken = accessToken;
      this.storefrontUser.idToken = idToken;

      window.localStorage.setItem(
        this.localStorageKeys.accessToken,
        accessToken,
      );
      window.localStorage.setItem(this.localStorageKeys.idToken, idToken);

      return true;
    } catch (error) {
      throw error;
    }
  }

  async request(data) {
    if (!this.storefrontUser.idToken) {
      this.error('User is not logged in');
      return;
    }

    try {
      let response = await fetch(`https://graphql.skio.com/v1/graphql`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + this.storefrontUser.idToken,
          userpoolid: 'us-west-2_ky2hNEMAZ',
          region: 'us-west-2',
        },
        body: JSON.stringify(data),
      });

      let responseData = await response.json();

      if (responseData.errors) {
        if (
          responseData.errors[0].message ==
            'Invalid response from authorization hook' ||
          responseData.errors[0].message ==
            'Authentication hook unauthorized this request'
        ) {
          this.log('Auth Error: refreshing tokens...');
          await this.getNewToken(
            this.clientId,
            this.storefrontUser.refreshToken,
          );
          return await this.request(data);
        } else {
          throw responseData.errors;
        }
      }

      return responseData;
    } catch (error) {
      throw error;
    }
  }

  async getCreditBalance() {
    this.log('Fetching credit balance information...');

    try {
      const response = await fetch(
        'https://api.skio.com/storefront-v2-http/get-credit-balance',
        {
          method: 'POST',
          body: JSON.stringify({
            token: this.storefrontUser.idToken,
            region: 'us-west-2',
            userPoolId: 'us-west-2_ky2hNEMAZ',
          }),
        },
      );

      const data = await response.json();

      if (!response.ok) {
        if (data.msg == 'jwt expired') {
          this.log('JWT expired, refreshing tokens...');
          await this.getNewToken();
          return await this.getCreditBalance();
        }

        throw new Error(`Failed to get credit balance ${data.msg}`);
      }

      return data;
    } catch (error) {
      throw error;
    }
  }

  async getSiteCreditRewards() {
    this.log('Fetching site credit rewards information...');

    try {
      const response = await fetch(
        'https://api.skio.com/storefront-v2-http/get-site-credit-rewards',
        {
          method: 'POST',
          body: JSON.stringify({
            domain: this.domain,
          }),
        },
      );

      const data = await response.json();

      if (!response.ok) {
        if (data.msg == 'jwt expired') {
          this.log('JWT expired, refreshing tokens...');
          await this.getNewToken();
          return await this.getSiteCreditRewards();
        }

        throw new Error('Failed to get site credit rewards');
      }

      return data;
    } catch (error) {
      throw error;
    }
  }

  async getCustomerRewardState() {
    this.log('Fetching customer reward state information...');

    try {
      const response = await fetch(
        'https://api.skio.com/storefront-v2-http/get-customer-reward-state',
        {
          method: 'POST',
          body: JSON.stringify({
            token: this.storefrontUser.idToken,
            region: 'us-west-2',
            userPoolId: 'us-west-2_ky2hNEMAZ',
          }),
        },
      );

      const data = await response.json();

      if (!response.ok) {
        if (data.msg == 'jwt expired') {
          this.log('JWT expired, refreshing tokens...');
          await this.getNewToken();
          return await this.getCustomerRewardState();
        }

        throw new Error('Failed to get customer reward state');
      }

      return data;
    } catch (error) {
      throw error;
    }
  }

  async getSiteTierRewards() {
    this.log('Fetching site tier rewards information...');

    try {
      const response = await fetch(
        'https://api.skio.com/storefront-v2-http/get-site-tier-rewards',
        {
          method: 'POST',
          body: JSON.stringify({
            domain: this.domain,
            email: this.storefrontUser.email,
          }),
        },
      );

      const data = await response.json();

      if (!response.ok) {
        if (data.msg == 'jwt expired') {
          this.log('JWT expired, refreshing tokens...');
          await this.getNewToken();
          return await this.getSiteTierRewards();
        }

        throw new Error('Failed to get site tier rewards');
      }

      return data;
    } catch (error) {
      throw error;
    }
  }

  async getCustomerInformation() {
    this.log('Fetching customer information...');

    const data = {
      query: `
      query getCustomerInformation($id: uuid!) {
        StorefrontUserByPk(id: $id) {
          id
          firstName
          lastName
          email
          createdAt
        }
      }`,
      variables: {
        id: this.storefrontUser.id,
      },
    };

    try {
      const response = await this.request(data);

      const {
        data: { StorefrontUserByPk },
      } = response;
      if (!StorefrontUserByPk)
        throw new Error('Failed to get customer information');

      return StorefrontUserByPk;
    } catch (error) {
      throw error;
    }
  }

  async getReferralCode() {
    this.log('Fetching customer referral code...');

    const data = {
      query: `
      query getReferralCode($id: uuid!) {
        StorefrontUserByPk(id: $id) {
          id
          ReferralDiscountCodes {
            referralCode
          }
        }
      }`,
      variables: {
        id: this.storefrontUser.id,
      },
    };

    try {
      const response = await this.request(data);

      const {
        data: { StorefrontUserByPk },
      } = response;
      if (!StorefrontUserByPk)
        throw new Error('Failed to get customer referral code');

      return StorefrontUserByPk;
    } catch (error) {
      throw error;
    }
  }
}

if (!window.SkioSDK) {
  window.SkioSDK = SkioSDK;
} else {
  console.error('SkioSDK is already defined!');
}

class ExclusiveLoyaltyContent extends HTMLElement {
  constructor() {
    super();
    //this.attachShadow({ mode: 'open' });
    this.skio = new SkioSDK({ domain: window.Shopify.shop, debug: true });
    this.tierNames = [];
    this.render();
  }

  static get observedAttributes() {
    return ['tier-names'];
  }

  renderSwiper(targetSwiper,navLeft = false,navRight = false) {
    if(targetSwiper){
      let swiperConfig = {
        slidesPerView: 1.3,
        spaceBetween: 16,
        loop: false,
        breakpoints:{
          1024: { 
            spaceBetween: 24,
            slidesPerView: 4,
          }
        }
      }

      if(navLeft && navRight){
        swiperConfig.navigation = {
          nextEl: navRight,
          prevEl: navLeft,
        }
      }

      const swiperInstance = new Swiper(targetSwiper, swiperConfig);
    }else{
      console.log("targetSwiper not provided to function - unable to initiate this swiper.");
    }
  }


  renderSwipers() {
    if(window.recipeSwiperInitialised === false){
      const recipeSwiperExclusiveContent = document.querySelector("exclusive-loyalty-content.loyalty-content-recipes .active-skio-content");
      if(recipeSwiperExclusiveContent){

        const recipeSwiper = recipeSwiperExclusiveContent.querySelector(".swiper");
        const navigationWrapper = document.querySelector(".skio-loyalty-rewards-section__recipes-header__header-navigation");

        if(recipeSwiper){
          const navLeft = navigationWrapper?.querySelector(".skio-loyalty-rewards-section__recipes-header__header-navigation-left");
          const navRight = navigationWrapper?.querySelector(".skio-loyalty-rewards-section__recipes-header__header-navigation-right");
          if(navLeft && navRight){
            this.renderSwiper(recipeSwiper,navLeft,navRight);
          }else{
            this.renderSwiper(recipeSwiper);
          }
        }else{
          this.renderSwiper(recipeSwiper);
        }
      }
    }

    if(window.merchSwiperInitialised === false){    
      const merchSwiperExclusiveContent = document.querySelector("exclusive-loyalty-content.loyalty-content-gifts .active-skio-content");
      if(merchSwiperExclusiveContent){

        const merchSwiper = merchSwiperExclusiveContent.querySelector(".swiper");
        const navigationWrapper = document.querySelector(".skio-loyalty-rewards-section__gifts-header__header-navigation");

        if(merchSwiper){
          const navLeft = navigationWrapper?.querySelector(".skio-loyalty-rewards-section__gifts-header__header-navigation-left");
          const navRight = navigationWrapper?.querySelector(".skio-loyalty-rewards-section__gifts-header__header-navigation-right");
          if(navLeft && navRight){
            this.renderSwiper(merchSwiper,navLeft,navRight);
          }else{
            this.renderSwiper(merchSwiper);
          }
        }else{
          this.renderSwiper(merchSwiper);
        }
      }

    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'tier-names') {
      this.tierNames = newValue.split(',').map(tier => tier.trim());
      this.updateContentVisibility();
    }
  }

  connectedCallback() {
    // Move all child nodes into the shadow DOM
    /*
    const contentWrapper = this.shadowRoot.querySelector('.content-wrapper');
    while (this.firstChild) {
      contentWrapper.appendChild(this.firstChild);
    }*/
    this.updateContentVisibility();
  }

  async updateContentVisibility() {
    // Hide all content initially
    const contentWrapper = this.querySelector('.content-wrapper');
    if (contentWrapper) {
      contentWrapper.style.display = 'none';
    }

    const isLoggedIn = this.skio.checkLogin();
    
    if (!isLoggedIn) {
      console.log("not logged in");
      this.showFallbackContent();
      return;
    }

    console.log('skio:', this.skio);

    try {
      const siteTiers = await this.skio.getSiteTierRewards();
      const currentTier = siteTiers.userTierName || '';      

      // Hide all tier-specific content first
      this.tierNames.forEach(tier => {
        const tierContent = this.querySelector(`[data-tier="${tier}"]`);
        if (tierContent) {
          tierContent.style.display = 'none';
        }
      });

      // Show content for current tier if it exists
      if (currentTier && this.tierNames.includes(currentTier)) {
        const currentTierContent = this.querySelector(`[data-tier="${currentTier}"]`);

        if (currentTierContent) {
          currentTierContent.style.display = 'block';
          contentWrapper.style.display = 'block';
          currentTierContent.classList.add("active-skio-content");
          this.renderSwipers();      
        } else {
          this.showFallbackContent();
        }
      } else {
        this.showFallbackContent();
      }
    } catch (error) {
      console.error('Error updating content visibility:', error);
      this.showFallbackContent();
    }
  }

  showFallbackContent() {

    const fallbackContent = this.querySelector('[data-tier="fallback"]');
    const contentWrapper = this.querySelector('.content-wrapper');
    if (fallbackContent) {
      fallbackContent.style.display = 'block';
      contentWrapper.style.display = 'block';
      fallbackContent.classList.add("active-skio-content");
      this.renderSwipers();
    }
  }

  render() {
    const style = document.createElement('style');
    style.textContent = `
      :host {
        display: block;
      }
      .content-wrapper {
        display: none;
      }
      [data-tier] {
        display: none;
      }      
    `;

    const contentWrapper = document.createElement('div');
    contentWrapper.className = 'content-wrapper';
    
    this.appendChild(style);
    this.appendChild(contentWrapper);
  }
}

const hackInCustomSection = () => {
  const targetPath = "/a/account/loyalty";

  let lastPath = location.pathname;

  const initLoyaltyLogic = () => {

    const target = document.querySelector(".loyalty-overview");
    if (target && !target.dataset.enhanced) {

      //Ensure our section isn't already there before adding it a second time! - This will prevent any of the custom additions from being added
      const customSection = document.querySelector(".skio-custom-section");

      if(!customSection){

        const createdEls = [];

        const nextOrderSectionContent = document.querySelector("#skio-next-order-section");
        if(nextOrderSectionContent){
          const nextOrderEl = document.createElement("div");
          nextOrderEl.classList.add("skio-loyalty-next-order","skio-custom-section")
          nextOrderEl.innerHTML = nextOrderSectionContent ? JSON.parse(nextOrderSectionContent.textContent) : '';
          target.append(nextOrderEl);
          createdEls.push(nextOrderEl);

          target.dataset.enhanced = "true";
        }

        // Exclusive Recipes Section
        const exclusiveRescipesContent = document.querySelector("#skio-exclusive-recipes-section");
        if(exclusiveRescipesContent){
          const exRecipesEl = document.createElement("div");
          exRecipesEl.classList.add("skio-loyalty-exclusive-recipes","skio-custom-section")
          exRecipesEl.innerHTML = exclusiveRescipesContent ? JSON.parse(exclusiveRescipesContent.textContent) : '';
          target.append(exRecipesEl);
          createdEls.push(exRecipesEl);

          target.dataset.enhanced = "true";
        }


        //Catch the page re-rendering itself and removing our content
        let runCount = 0;
        const maxRuns = 50;

        const watchdogInterval = setInterval(() => {
          const customSection = document.querySelector(".skio-custom-section");
          const loyaltyOverview = document.querySelector(".loyalty-overview");

          if (!customSection && loyaltyOverview) {
            createdEls.forEach(el => loyaltyOverview.append(el.cloneNode(true)));
          }

          runCount++;
          if (runCount > maxRuns) {
            clearInterval(watchdogInterval);
          }
        }, 200);


        /*

        Retired Section from Loyalty 1.0

        const newEl = document.createElement("div");
        newEl.classList.add("skio-custom-section");
        newEl.innerHTML = `
          <div class = "skio-custom-section__content">
              <div class = "skio-custom-section__content-titles">
                  <span>Gifts &amp; Recipes</span>
                  <p>View your exclusive gifts and secret recipes.</p>                    
              </div>
              <a href = "/pages/loyalty-rewards" class = "button">View Gifts &amp; Recipes</a>
          </div>
          <div class = "skio-custom-section__image-container">
              <img src = "https://cdn.shopify.com/s/files/1/0413/5600/1437/files/0909215_Bold_Bean_203_01_0442b9bd-31f0-483a-bb55-e53b4207869d.jpg?v=1759411739"
                  class = ""
                  alt = "Gifts &amp; Recipes"
                  title = "Gifts &amp; Recipes"
              />
          </div>
        `;
        */
      }
    }
  };
  
  const checkRouteChange = () => {
    const currentPath = location.pathname;
    if (currentPath !== lastPath) {
      lastPath = currentPath;
  
      // Only run on the route you care about
      if (currentPath === targetPath) {
        insertCustomSection();
      }
    }
  };
  
  // Wait for .loyalty-overview to exist before running logic
  const insertCustomSection = () => {
    const interval = setInterval(() => {
      const el = document.querySelector(".loyalty-overview");
      if (el) {
        initLoyaltyLogic();
        clearInterval(interval);
      }
    }, 300);
  };
  
  // Catch when the url changes
  setInterval(checkRouteChange, 300);
  
  // If we're already on the loyalty page, output it
  if (location.pathname === targetPath) {
    insertCustomSection();
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const skioLoyaltySection = document.querySelector(".skio-loyalty-rewards-section");
  if(skioLoyaltySection){
    customElements.define('exclusive-loyalty-content', ExclusiveLoyaltyContent);
  }

  //Do we need to run the checkout for our custom section?
  if(window.location.pathname.includes("/a/")){
    hackInCustomSection();
  }

  //Bind any "Read More" overlays
  bindReadMoreOverlays();
});
